$(document).ready(function () {
    $("#upload_overige_button").click(function () {
        $("#overige_input").click();
    });
    $("#upload_omzendbrief_button").click(function () {
        $("#omzend_input").click();
    });

    $("#omzend_input").change(function () {
        $("#omzendbrieven").submit();
    });
    $("#overige_input").change(function () {
        $("#overige").submit();
    });

    //Save info
    let regexARSuc = /\/[B|b]estanden\/Upload\/Success/;
    let regexARFail = /\/[B|b]estanden\/Upload\/Failed/;
    let regexDeleteSuc = /\/[B|b]estanden\/DeleteSuccess/;
    let regexDeleteFail = /\/[B|b]estanden\/DeleteFailed/;
    if (regexARSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bestanden', '/Bestanden');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexARFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bestanden', '/Bestanden');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexDeleteSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bestanden', '/Bestanden');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexDeleteFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Bestanden', '/Bestanden');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/bestanden.js
// module id = 14
// module chunks = 0